import { UserData } from "pages/SignUpPage";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { LoginWithDiscord } from "store/actions/authActions/LoginWithDiscord";
import loadingSpinner from "../../assets/svg/spinner-blue.svg";
import { LoginWithGoogle } from "store/actions/authActions/LoginWithGoogle";
import { SimpleClientRegister } from "store/actions/authActions/SimpleClientRegister";
import { useAppDispatch } from "store/hooks";
import { SkipButton } from "./SkipButton";
import { useWindowSize } from "hooks/useWindowSize";

interface Props {
  setSignInRedirect: React.Dispatch<React.SetStateAction<boolean>>;
  googleToken: string | null;
  discordCode: string | null;
  skipButtonIsLoading: boolean;
  setSkipButtonIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  qrTokenToValidate: string | undefined;
  setUserData: React.Dispatch<React.SetStateAction<UserData | null>>;
  setForbiddenError: React.Dispatch<React.SetStateAction<boolean>>;
  setEmailInUseError: React.Dispatch<React.SetStateAction<boolean>>;
  userData: UserData | null;
  setShowForm: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AreYouReferredPrompt: React.FC<Props> = ({
  setSignInRedirect,
  googleToken,
  discordCode,
  skipButtonIsLoading,
  setSkipButtonIsLoading,
  qrTokenToValidate,
  setUserData,
  setForbiddenError,
  userData,
  setEmailInUseError,
  setShowForm,
}) => {
  const [noButtonIsLoading, setNoButtonIsloading] = useState<boolean>(false);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const language = t("localization_testing");
  const [width] = useWindowSize();
  const referrerCode = localStorage.getItem("referrerCode");

  useEffect(() => {
    if (!!referrerCode) {
      setShowForm(true);
    }
  }, [referrerCode, setShowForm]);

  return (
    <div className="w-full h-full ">
      <h1 className="text-2xl font-semibold pt-2 text-center text-blue-500">
        {t("refer.areYouReferred")}
      </h1>
      <div className="flex w-1/2 mx-auto justify-between items-center pt-10 md:pt-20 pb-10 text-blue-500">
        <button
          type="button"
          onClick={() => setShowForm(true)}
          className="w-20 h-10 border-2 border-blue-500 rounded-md"
        >
          {t("refer.yes")}
        </button>
        <button
          type="button"
          className="w-20 h-10  border-2 border-blue-500 rounded-md"
          onClick={() => {
            if (!!discordCode) {
              dispatch(
                LoginWithDiscord(
                  language,
                  discordCode,
                  true,
                  true,
                  setSignInRedirect,
                  navigate,
                  qrTokenToValidate
                )
              );
              localStorage.removeItem("promoCode");
            }
            if (!!googleToken) {
              dispatch(
                LoginWithGoogle(
                  language,
                  googleToken,
                  true,
                  true,
                  navigate,
                  setSignInRedirect,
                  setNoButtonIsloading,
                  qrTokenToValidate
                )
              );
              localStorage.removeItem("promoCode");
            }
            if (!!userData) {
              dispatch(
                SimpleClientRegister(
                  userData.firstName,
                  userData.lastName,
                  userData.email,
                  userData.password,
                  setNoButtonIsloading,
                  setEmailInUseError,
                  setForbiddenError,
                  setSignInRedirect,
                  navigate,
                  dispatch,
                  language,
                  width,
                  qrTokenToValidate
                )
              );
            }
          }}
        >
          <span>
            {noButtonIsLoading ? (
              <div className="w-full flex items-center justify-center">
                <img
                  className="animate-spin"
                  src={loadingSpinner}
                  alt="loading"
                />
              </div>
            ) : (
              <span>{t("refer.no")}</span>
            )}
          </span>
        </button>
      </div>
      <p className="text-center w-3/4 mx-auto">{t("refer.referredSubtext")}</p>
      <div className="w-full flex pt-8 justify-end ">
        <div className="-mb-4 pr-2 lg:pr-0">
          <SkipButton
            setRedirect={setSignInRedirect}
            googleToken={googleToken}
            discordCode={discordCode}
            skipButtonIsLoading={skipButtonIsLoading}
            setSkipButtonIsLoading={setSkipButtonIsLoading}
            qrTokenToValidate={qrTokenToValidate}
            setUserData={setUserData}
            setForbiddenError={setForbiddenError}
            userData={userData}
            setEmailInUseError={setEmailInUseError}
          />
        </div>
      </div>
    </div>
  );
};
